import(/* webpackMode: "eager", webpackExports: ["StaticAppFrame"] */ "/Volumes/repository/devel/electrical/commerce/frontends/storefront/src/components/staticApps/StaticAppFrame.tsx");
